import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { ApkFileData, ApkInfo } from '@/types/apk.types'

export const apkService = {
  getDefault: async (): Promise<ApkInfo | null> => {
    return apiClient.get<ApkInfo | null>(API_ENDPOINTS.APK.DEFAULT)
  },

  uploadDefault: async (file: File): Promise<ApkInfo> => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.patch<ApkInfo>(API_ENDPOINTS.APK.DEFAULT, formData)
  },

  getAssigned: async (): Promise<ApkInfo | null> => {
    return apiClient.get<ApkInfo | null>(API_ENDPOINTS.APK.ASSIGNED)
  },

  downloadAssigned: async (): Promise<ApkFileData> => {
    return apiClient.get<ApkFileData>(API_ENDPOINTS.APK.ASSIGNED_DOWNLOAD)
  },

  getActor: async (userId: string): Promise<ApkInfo | null> => {
    return apiClient.get<ApkInfo | null>(API_ENDPOINTS.APK.USER(userId))
  },

  uploadActor: async (userId: string, file: File): Promise<ApkInfo> => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.patch<ApkInfo>(API_ENDPOINTS.APK.USER(userId), formData)
  },

  clearActor: async (userId: string): Promise<ApkInfo | null> => {
    return apiClient.delete<ApkInfo | null>(API_ENDPOINTS.APK.USER(userId))
  },
}
